import React, { useEffect, useState } from "react"
import { PriceVision } from "../../models/bid/PriceVision"
import { useAppContext } from "../../contexts/AppContext"
import { client } from "../.."
import { getPriceVision } from "../../api/price_vision"
import { showErrorMessage } from "../../helper/helper"
import { PriceChart } from "../companies/charts/PriceChart"
import { PriceGradingChart } from "../companies/charts/PriceGradingChart"
import { ContractChart } from "../companies/charts/ContractChart"
import { t } from "i18next"
import { colorPrimary, colorPrimaryStatic } from "../../rsc/colors/colors"
import { Button } from "@mui/material"

export type PeriodType = 'week' | 'month' | 'year'

export const MillBusiness = () => {

    const [priceVision, setPriceVision] = useState<PriceVision[]>()
    const [period, setPeriod] = useState<PeriodType>('month')

    const { millSelected } = useAppContext()

    useEffect(() => {
        if (millSelected?.id) {
            const variables = {
                "rawFilter": {
                    "mill_id": {
                        "$in": [millSelected.id]
                    },
                    "bid_close": { "$ne": null }
                }
            }
            client.query({
                query: getPriceVision,
                variables: variables
            }).then(result => {
                console.log(result)
                const vision = result.data.price_vision?.map((o) => PriceVision.buildPriceVision(o))
                setPriceVision(vision)
            }).catch(e => showErrorMessage(e))
        }
    }, [millSelected])

    const getPeriodButtonStyle = (buttonPeriod: PeriodType): React.CSSProperties => {
        return {
            padding: '8px 16px',
            margin: '2px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            backgroundColor: period === buttonPeriod ? colorPrimaryStatic() : 'white',
            color: period === buttonPeriod ? 'white' : colorPrimaryStatic(),
            cursor: 'pointer',
            fontSize: '12px',
            height: '30px'
        }
    }


    return <div>
        <div className='pempem-flex-col header'>
            <h1>{t("business_data")}</h1>
        </div>
        <div className="page-padding">
            <div className='view-selector pempem-flex-row-end'>
                <Button
                    style={getPeriodButtonStyle('week')}
                    onClick={() => setPeriod('week')}
                >
                    {t('week')}
                </Button>
                <Button
                    style={getPeriodButtonStyle('month')}
                    onClick={() => setPeriod('month')}
                >
                    {t('month')}
                </Button>
                <Button
                    style={getPeriodButtonStyle('year')}
                    onClick={() => setPeriod('year')}>
                    {t('year')}
                </Button>
            </div>
            <PriceChart priceVisions={priceVision} period={period} />
            {/* On reload the mill is only selected once the profile has loaded. */}
            {millSelected && <>
                <PriceGradingChart priceVisions={priceVision} millId={millSelected.id} period={period} />
                <ContractChart priceVisions={priceVision} millId={millSelected.id} period={period} />
            </>}
        </div>
    </div>
}